<template>
  <div class="analysis-element-global" :id="`analysis-element-${item.id}`">
    <v-row no-gutters class="flex-grow-1 fill-height my-2 p-relative">
      <AnalysisElementVotes
        :item="item"
        :user-analysis-id="userAnalysis.id"
        :analysis-id="analysisId"
        :user-id="userDetails.userId"
      />
      <AnalysisThread
        :item="item"
        :title="title"
        :analysis-id="analysisId"
        :read-only="readOnly"
        ref="elementThread"
        @archiveElement="archiveElement"
        @archiveThreadComment="archiveThreadComment"
      />
      <v-col class="mr-6" style="max-width: 50px;">
        <CodeSVG
          :selected-tile="item.codeClassification !== undefined ? item.codeClassification : ''"
          :read-only="readOnly"
          @newSelection="updateCodeClassification"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters, mapActions } from 'vuex';
import AnalysisThread from './AnalysisThread';
import AnalysisElementVotes from './votes/AnalysisElementVotes';
import CodeSVG from '../code/CodeSVG';
import { types as analysesTypes } from '../../store/analyses';
import { types as userTypes } from '../../store/user';

export default {
  name: 'AnalysisElement',
  components: {
    AnalysisThread,
    CodeSVG,
    AnalysisElementVotes,
  },
  props: {
    userAnalysis: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    analysisId: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      userDetails: userTypes.getters.userDetails,
    }),
    title() {
      switch (this.type) {
        case 'comment':
          return this.$t('extension.userAnalyses.events.commented');
        case 'highlight':
          return this.$t('extension.userAnalyses.events.highlighted');
        case 'mission':
          return this.$t('extension.userAnalyses.events.added');
        default:
          throw new Error(`Invalid Type '${this.type}'`);
      }
    },
  },
  methods: {
    ...mapActions({
      updateUserAnalysisElement: analysesTypes.actions.updateUserAnalysisElement,
    }),
    archiveElement() {
      this.$emit('archiveElement', this.item);
    },
    archiveThreadComment(commentId) {
      this.$emit('archiveThreadComment', commentId);
    },
    updateCodeClassification(newClass) {
      const updatedElement = cloneDeep(this.item);
      updatedElement.codeClassification = newClass;
      this.updateUserAnalysisElement({
        userAnalysis: this.userAnalysis,
        element: updatedElement,
      });
    },
  },
};
</script>
<style>
.blue-background {
  background-color: rgba(60, 68, 200, 0.1);
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.analysis-element-global {
  transition: all 0.3s ease-in-out;
}
</style>
